"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Toothbrush(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M18.795.61l3.535 3.535-7.84 7.841c.944 1.47.777 3.464-.504 4.744L7.716 23a2.35 2.35 0 0 1-3.3 0l-2.355-2.355a2.348 2.348 0 0 1 .002-3.301l6.267-6.27a3.791 3.791 0 0 1 2.688-1.107c.718 0 1.435.204 2.058.605l2.184-2.185-2.121-2.121 1.414-1.414 2.12 2.12.708-.706-2.121-2.121 1.414-1.415 2.12 2.122.708-.707-2.121-2.122L18.795.61zm-7.777 11.345c-.459 0-.918.178-1.274.533l-6.27 6.27a.321.321 0 0 0 0 .472l2.358 2.356c.14.14.332.14.47 0l6.27-6.27c.711-.71.711-1.834 0-2.545l-.283-.283a1.792 1.792 0 0 0-1.271-.533zm-.707 1.38L8.896 14.75l1.415 1.416 1.414-1.414-1.414-1.416z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Toothbrush;
